import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ClientAppContentContent} from "./ClientAppContentContent";
import {withRouterParams} from "../../utils/withRouterParams";

class ClientAppContent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar />
                <ClientAppContentContent clientId={this.props.match.params.client_id}
                                         appHash={this.props.match.params.app_hash}/>
            </div>
        )
    }
}

export default withRouterParams(ClientAppContent);

